export default __webpack_public_path__ + "static/media/prod1.8c7d7724.jpg";